import React, { useState, useCallback } from 'react';
import { Button, Switch, TableCell, TableRow } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import OrderUpdateForm from './OrderUpdateForm';
import AlertDialog from '../AlertDialog'; // Adjust the import path as needed
import { CarouselType } from '../../types/types';
import { IMG_BASE_URL } from '../../utils/config';

interface CarouselItemProps {
  carousel: CarouselType;
  index: number;
  onSubmit: (data: { order: number }, id: number) => Promise<void>;
  handleDelete: (id: number) => Promise<void>;
  handleChangeActive: (event: React.ChangeEvent<HTMLInputElement>, id: number) => Promise<void>;
}

const CarouselItem: React.FC<CarouselItemProps> = ({ carousel, index, onSubmit, handleDelete, handleChangeActive }) => {
  const [showAlert, setShowAlert] = useState<boolean>(false);

  const handleDeleteClick = useCallback(() => {
    setShowAlert(true);
  }, []);

  const handleConfirmDelete = useCallback(async () => {
    await handleDelete(carousel.id);
    setShowAlert(false);
  }, [handleDelete, carousel.id]);

  const handleCancelDelete = useCallback(() => {
    setShowAlert(false);
  }, []);

  return (
    <>
      <TableRow key={carousel.id}>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          <img
            src={`${IMG_BASE_URL}${carousel.link}`}
            style={{ width: '120px' }}
            alt={carousel.photoFilename}
            loading="lazy"
          />
        </TableCell>
        <TableCell align="left">{carousel.photoFilename}</TableCell>
        <TableCell align="left">
          <OrderUpdateForm
            defaultOrder={carousel.order}
            onSubmit={(data) => onSubmit(data, carousel.id)}
          />
        </TableCell>
        <TableCell align="center">
          <Switch
            checked={carousel.active}
            onChange={(event) => handleChangeActive(event, carousel.id)}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </TableCell>
        <TableCell align="center" sx={{ whiteSpace: 'nowrap' }}>
          <Button
            onClick={handleDeleteClick}
            variant="contained"
            size="small"
            color="error"
          >
            <DeleteIcon />
          </Button>
        </TableCell>
      </TableRow>
      <AlertDialog
        toggle={showAlert}
        setToggle={setShowAlert}
        cancel={handleCancelDelete}
        confirm={handleConfirmDelete}
        title="Are you sure?"
        content="You want to delete this carousel item."
        type="error"
      />
    </>
  );
};

export default CarouselItem;
